import { defaultActionCreator } from './actionCreator';

export const GET_ADDRESS_CONFIG_REQUEST = 'GET_ADDRESS_CONFIG_REQUEST'
export const GET_ADDRESS_CONFIG_SUCCESS = 'GET_ADDRESS_CONFIG_SUCCESS'
export const GET_ADDRESS_CONFIG_FAILED = 'GET_ADDRESS_CONFIG_FAILED'
export const getAddressConfigRequest = defaultActionCreator(GET_ADDRESS_CONFIG_REQUEST, 'data')
export const getAddressConfigSuccess = defaultActionCreator(GET_ADDRESS_CONFIG_SUCCESS, 'data')
export const getAddressConfigFailed = defaultActionCreator(GET_ADDRESS_CONFIG_FAILED, 'error')
